import { z } from 'zod';

/**
 * CPF mascarado, DISPLAY-ONLY no wire dos cards (renderizado cru). Usado por
 * `flight_reservation`.
 *
 * Exige a estrutura de CPF com o grupo do meio SEMPRE mascarado (`***`) — garante
 * que um número cru não vaze pelo boundary. Tolera os dois formatos mascarados em
 * uso: o do handoff (`123.***.**9-00`) e o do businessApproval (`044.***.***-**`).
 * `includes('*')` sozinho seria fraco demais (aceitaria `123.456.789-00*`).
 */
const MASKED_CPF_RE = /^(?:\d{3}\.\*{3}\.\*{2}\d-\d{2}|\d{3}\.\*{3}\.\*{3}-\*{2})$/;
export const ChatUiMaskedDocumentSchema = z.string().regex(MASKED_CPF_RE, {
  message: 'document deve vir mascarado (ex.: 123.***.**9-00)',
});
